var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 14,
    cy: 14,
    r: 14,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1105_1783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 19.04C21 19.352 20.8847 19.59 20.6541 19.754C20.4235 19.918 20.1405 20 19.805 20H8.19497C7.85954 20 7.57652 19.916 7.34591 19.748C7.1153 19.58 7 19.344 7 19.04C7 18.8 7.07547 18.556 7.22642 18.308L13.0252 8.66C13.3019 8.22 13.6289 8 14.0063 8C14.3836 8 14.7023 8.22 14.9623 8.66L20.7736 18.32C20.9245 18.576 21 18.816 21 19.04ZM14.8742 12.908V11.156H13.1258V12.908C13.1258 13.02 13.1342 13.126 13.1509 13.226C13.1677 13.326 13.1908 13.438 13.2201 13.562C13.2495 13.686 13.2725 13.792 13.2893 13.88L13.6164 15.824H14.3585L14.6981 13.88C14.7149 13.8 14.74 13.696 14.7736 13.568C14.8071 13.44 14.8323 13.326 14.8491 13.226C14.8658 13.126 14.8742 13.02 14.8742 12.908ZM14.8742 17.552C14.8742 17.32 14.7883 17.124 14.6164 16.964C14.4444 16.804 14.2369 16.724 13.9937 16.724C13.7589 16.724 13.5556 16.804 13.3836 16.964C13.2117 17.124 13.1258 17.32 13.1258 17.552C13.1258 17.784 13.2117 17.982 13.3836 18.146C13.5556 18.31 13.7589 18.392 13.9937 18.392C14.2369 18.392 14.4444 18.31 14.6164 18.146C14.7883 17.982 14.8742 17.784 14.8742 17.552Z",
    fill: "#FF9500"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1105_1783"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 12,
    fill: "white",
    transform: "translate(7 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/Icon_warning.49c1062f40c4edc3be0f6dbbc4a5b0ab.svg";
export { ForwardRef as ReactComponent };